import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Benefits from './components/Benefits';
import Details from './components/Details';
import Registration from './components/Registration';
import Footer from './components/Footer';

export default function Home() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-teal-600" style={{ fontFamily: 'Pacifico, serif' }}>
                Vision Map
              </h1>
            </div>
            
            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="#about" className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">
                セミナーについて
              </a>
              <a href="#benefits" className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">
                得られる効果
              </a>
              <a href="#details" className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">
                開催概要
              </a>
              <a 
                href="#registration" 
                className="bg-teal-600 text-white px-6 py-2 rounded-full hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                お申し込み
              </a>
            </div>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-md text-gray-700 hover:text-teal-600 hover:bg-gray-100 cursor-pointer"
              aria-label="メニュー"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
              </div>
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="md:hidden py-4 border-t border-gray-200">
              <div className="flex flex-col space-y-4">
                <a 
                  href="#about" 
                  className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer"
                  onClick={() => setIsMenuOpen(false)}
                >
                  セミナーについて
                </a>
                <a 
                  href="#benefits" 
                  className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer"
                  onClick={() => setIsMenuOpen(false)}
                >
                  得られる効果
                </a>
                <a 
                  href="#details" 
                  className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer"
                  onClick={() => setIsMenuOpen(false)}
                >
                  開催概要
                </a>
                <a 
                  href="#registration" 
                  className="bg-teal-600 text-white px-6 py-2 rounded-full hover:bg-teal-700 transition-colors text-center cursor-pointer whitespace-nowrap"
                  onClick={() => setIsMenuOpen(false)}
                >
                  お申し込み
                </a>
              </div>
            </div>
          )}
        </nav>
      </header>

      {/* Main Content */}
      <main>
        <Hero />
        <About />
        <Benefits />
        <Details />
        <Registration />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
